import cache from "@/cache"
import i18n from "@/i18n";
import type { SupportedLocales } from "@/types/lang";


export async function fetchLocale() {
    const storedLocale = await cache.lang?.getValue("locale");
    if (storedLocale) {
        i18n.global.locale.value = storedLocale;
    } else {
        await cache.lang?.saveValue("locale", i18n.global.locale.value)
    }
}  

export async function setLocale(locale: SupportedLocales) {
    i18n.global.locale.value = locale;
    cache.lang?.saveValue("locale", locale)
}